/**
 * Utility functions for word processing and normalization.
 */

/**
 * Normalizes a word by trimming whitespace, converting to lowercase, 
 * and removing common punctuation marks except apostrophes.
 * 
 * @param {string} text - The text to normalize
 * @returns {string} - The normalized text
 */
export const normalizeWord = (text) => {
    if (!text) return '';
    // Trim whitespace, lowercase, and remove common punctuation EXCEPT apostrophes
    return text.trim().toLowerCase().replace(/[.,;:!?"()]/g, '');
};

/**
 * Checks if a string contains Japanese characters.
 * 
 * @param {string} text - The text to check
 * @returns {boolean} - True if text contains Japanese characters
 */
export const containsJapanese = (text) => {
    if (!text) return false;
    // Check for Hiragana, Katakana, or Kanji
    return /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]/.test(text);
};

/**
 * Checks if a character is a Kanji.
 * 
 * @param {string} char - The character to check
 * @returns {boolean} - True if the character is a Kanji
 */
export const isKanji = (char) => {
    if (!char || char.length !== 1) return false;
    // Check if the character is in the CJK Unified Ideographs range
    return /[\u4E00-\u9FFF]/.test(char);
}; 